module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-img', {
    staticClass: "rounded-circle",
    attrs: {
      "src": _vm.urlImage,
      "gradient": _vm.gradient ? 'to bottom, rgba(0,0,0,.1),#161f2b85' : '',
      "loading": _vm.isLoading
    },
    on: {
      "error": function($event) {
        _vm.urlImage = '/static/nobody.jpg'
      }
    }
  }, [(_vm.isLoading) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "indeterminate",
      "color": "primary",
      "size": "30"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2eb27b4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_avatar_perfil.vue
// module id = 532
// module chunks = 1